import React from "react";
import List from "components/common/List";
import Badge from "components/common/Badge";

import BookingCard from "./BookingCard";

import { BOOKING_STATUS } from "utils/constant";
import { assign, get, map, filter } from "utils/lodash";
import cx from "classnames";
import helper from "utils/helper";
import { useBookingStore } from "stores";
import dayjs from "utils/dayjs";
const mockBookings: any = [
  // Large array of mock data
];

const blockTimes = [
  {
    id: 1,
    time: "09:00 - 10:30",
    date: "02/02/2020",
  },
  {
    id: 2,
    time: "10:30 - 12:00",
    date: "02/02/2020",
  },
  {
    id: 3,
    time: "13:00 - 14:30",
    date: "02/02/2020",
  },
];

const FILTERS = [
  {
    label: "Tất cả booking",
    value: "all",
  },
  {
    label: "Đang chờ nhận",
    value: "waiting",
  },
  {
    label: "Đã xác nhận",
    value: "accepted",
  },
  {
    label: "Đã hủy",
    value: "cancelled",
  },
  {
    label: "Đã thanh toán",
    value: "done",
  },
];
export default function TabAppointment({ onAccept, onMore }: any) {
  const { bookings, selectedDate } = useBookingStore();
  const [filterStatus, $filterStatus] = React.useState("all");

  // Filter bookings for current selected date
  const currentBookings = filter(bookings || [], (booking: any) => {
    return dayjs(get(booking, "bookingDate")).isSame(
      selectedDate,
      "day"
    );
  });

  const filterdBookings = filter(currentBookings, (booking: any) => {
    if (filterStatus === "all") return true;
    if (filterStatus === "cancelled") {
      return booking.status === "cancelled";
    }
    return booking.status === filterStatus;
  });
  return (
    <div className="h-full overflow-y-auto pb-4 scrollbar-hide">
      <div className="px-4 flex overflow-x-auto gap-2 mb-4 no-scrollbar [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        {map(FILTERS, (filter) => (
          <Badge
            key={filter.value}
            type="filter"
            label={filter.label}
            onClick={() => $filterStatus(filter.value)}
            isActive={filter.value === filterStatus}
          />
        ))}
      </div>
      <div className="flex flex-col gap-4 px-4">
        {filterdBookings && filterdBookings.length > 0 ? (
          map(filterdBookings, (booking) => (
            <BookingCard
              data={helper.formatBooking(booking)}
              key={booking.id}
              onMore={onMore}
              onAccept={onAccept}
            />
          ))
        ) : (
          <div className="flex flex-col items-center justify-center py-12">
            <div className="text-gray-400 mb-2">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 2V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 2V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              Chưa có lịch hẹn nào
            </h3>
            <p className="text-gray-500 text-center max-w-xs">
              {filterStatus === "all"
                ? "Hiện tại bạn chưa có lịch hẹn nào. Lịch hẹn mới sẽ xuất hiện ở đây."
                : filterStatus === "waiting"
                ? "Không có lịch hẹn nào đang chờ xác nhận."
                : filterStatus === "accepted"
                ? "Không có lịch hẹn nào đã được xác nhận."
                : filterStatus === "cancelled"
                ? "Không có lịch hẹn nào đã bị hủy."
                : "Không có lịch hẹn nào đã thanh toán."
              }
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
